export default __webpack_public_path__ + "static/media/logo-latinex.bf0a1856.svg";